import './parts/shopify/snippets';
import './parts/shopify/sections';
import './parts/shopify/templates';

import $ from 'jquery';
import '@popperjs/core';

import * as bootstrap from 'bootstrap';

import {
  App
} from './parts/app.js'
import {
  Plugins
} from './parts/plugins.js'
import {
  Parts
} from './parts/parts.js'


// export for others scripts to use
window.$ = $;
window.jQuery = jQuery;


$(function () {


  window.windowWidth = $(window).width();
  window.windowHeight = $(window).height();

  window.isiPhone = navigator.userAgent.toLowerCase().indexOf('iphone');
  window.isiPad = navigator.userAgent.toLowerCase().indexOf('ipad');
  window.isiPod = navigator.userAgent.toLowerCase().indexOf('ipod');

  //Functions List Below

  window.app = new App();
  window.app.init();

  window.plugins = new Plugins();
  window.plugins.init();

  window.parts = new Parts();
  window.parts.init();

});

// ===========================================================================

//================== header
$(window).scroll(function () {
  var currentScrollPos = $(window).scrollTop();
  var prevScrollPos = $(this).data('prevScrollPos') || 0;
  var header = $("header");

  var headerOffset = header.offset().top;
  var distance = (headerOffset - currentScrollPos);
  var mobileHeader = $(".top-header");




  if ($('body').width() < 768) {

    if (currentScrollPos >= 50) {
      mobileHeader.addClass("top-header-hide");
    } else {
      mobileHeader.removeClass("top-header-hide");
    }

    $(this).data('prevScrollPos', currentScrollPos);
  } else {
    if (prevScrollPos > currentScrollPos) {
      header.removeClass("header-hide");
      header.addClass("header-fixed");
    } else {
      header.addClass("header-hide");
    }

    // if (currentScrollPos >= 50) {
    //   header.addClass("header-fixed");
    // } else {
    //   header.removeClass("header-fixed");
    // }

    $(this).data('prevScrollPos', currentScrollPos);
  }
});

//============== toggle menu
$('.menu-toggle').click(function () {
  $(this).toggleClass('activate');
  $('header').toggleClass('menu-active');
  $('html').toggleClass('overflow-hidden');
});

if ($('body').width() < 768) {
  $('.mobile-hero-trigger').click(function () {
    event.preventDefault();
    $('.menu-toggle').toggleClass('activate');
    $('header').toggleClass('menu-active');
    $('html').toggleClass('overflow-hidden');


    $('#navigation').addClass('d-none');
    $('.menu-tab').insertAfter('.res-back');
    $('.nav-menu').addClass('menu-tabs');
    $('.menu-tab').addClass('d-block').removeClass('d-none');

    $('.back-1').click(function () {
      $('.menu-tab').addClass('d-none');
      $('#navigation').addClass('d-block').removeClass('d-none');
    })
  });
}

function responsive(maxWidth) {
  var maxWidth = window.matchMedia("(max-width: 991px)");
  if (maxWidth.matches) {
    $('.search').insertBefore('.nav-menu .res-back');
    $('.top-header .cart').insertAfter('.logo');
    $('#navigation').insertAfter('.search');
    $('.top-header .account').prependTo('.nav-menu .res-acount-cart');
  } else {
    $('.search').appendTo('.nav-bar');
    $('.top-header .cart').appendTo('.top-header .right-top-head');
    $('.top-header .account').prependTo('.top-header .right-top-head');
  }
}
var maxWidth = window.matchMedia("(max-width: 991px)");

responsive(maxWidth);
maxWidth.addListener(responsive);

$(window).on('resize', function () {
  var windowWidth = $(window).width();
  if (windowWidth <= 991) {
    $('.main-menu').click(function () {
      $('#navigation').addClass('d-none');
      $('.menu-tab').insertAfter('.res-back');
      $('.nav-menu').addClass('menu-tabs');
      $('.menu-tab').addClass('d-block').removeClass('d-none');
      $('.back-1').click(function () {
        $('.menu-tab').addClass('d-none');
        $('#navigation').addClass('d-block').removeClass('d-none');
      })
    });
    $('.tab1').click(function () {
      $('.menu-tab').addClass('d-none');
      $('.tab1-content').insertAfter('.res-back');
      $('.tab1-content').addClass('d-block').removeClass('d-none');
      $('.back-2').click(function () {
        $('.tab1-content').addClass('d-none');
        $('.menu-tab').addClass('d-block').removeClass('d-none');
      })
    });
    $('.tab2').click(function () {
      $('.menu-tab').addClass('d-none');
      $('.tab2-content').insertAfter('.res-back');
      $('.tab2-content').addClass('d-block').removeClass('d-none');
      $('.back-3').click(function () {
        $('.tab2-content').addClass('d-none');
        $('.menu-tab').addClass('d-block').removeClass('d-none');
      })
    });
    $('.tab3').click(function () {
      $('.menu-tab').addClass('d-none');
      $('.tab3-content').insertAfter('.res-back');
      $('.tab3-content').addClass('d-block').removeClass('d-none');
      $('.back-4').click(function () {
        $('.tab3-content').addClass('d-none');
        $('.menu-tab').addClass('d-block').removeClass('d-none');
      })
    });
    $('.tab4').click(function () {
      $('.menu-tab').addClass('d-none');
      $('.tab4-content').insertAfter('.res-back');
      $('.tab4-content').addClass('d-block').removeClass('d-none');
      $('.back-5').click(function () {
        $('.tab4-content').addClass('d-none');
        $('.menu-tab').addClass('d-block').removeClass('d-none');
      })
    });
  }
});

//============== media js
$(window).on('resize', function () {
  var windowWidth = $(window).width();
  if (windowWidth <= 991) {
    $('header').addClass('header-bg');
  } else {
    $('header').removeClass('header-bg');
  };
});


$(document).ready(function () {
  $("#closeFilters").click(function () {
    $("#slidebar-content").addClass("d-none");
  });
  $("#openFilters").click(function () {
    $("#slidebar-content").removeClass("d-none");
  });
})

//=============== menu tab 
$('.tab-a').click(function () {
  $(".tab").removeClass('tab-active');
  $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
  $(".tab-a").removeClass('active-a opacity-50');
  $(this).parent().find(".tab-a").addClass('active-a opacity-50');
});

//================== category filter tab 
$(".js-accordion-title").on("click", function () {
  $(this).toggleClass("active");
  var panel = $(this).next();
  if (panel.css("display") === "block") {
    panel.css("display", "none");
  } else {
    panel.css("display", "block");
  }
});

//==================== category filter tab see-more button
$(document).ready(function () {
  $('.toggle-btn').on('click', function () {
    var toggleId = $(this).data('toggle-id');
    $('#' + toggleId).toggle('active');
  });


  // =======================privacy-policy
  (function ($, window, document) {
    $('[data-toggle]').on('click', function (event) {
      event.preventDefault();
      var target = $(this.hash);
      target.toggle();
    });
    var lastId,
      topMenu = $("#policy-nav"),
      topMenuHeight = topMenu.outerHeight() + 15,
      menuItems = topMenu.find("a"),
      scrollItems = menuItems.map(function () {
        var item = $(this).attr("href");
        if (item != '#') {
          return $(item)
        }
      });
    menuItems.click(function (e) {
      var href = $(this).attr("href"),
        offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
      $('html, body').stop().animate({
        scrollTop: offsetTop
      }, 300);
      e.preventDefault();
    });
    $(window).scroll(function () {
      var fromTop = $(this).scrollTop() + topMenuHeight;
      var cur = scrollItems.map(function () {
        if ($(this).offset().top < fromTop)
          return this;
      });
      cur = cur[cur.length - 1];
      var id = cur && cur.length ? cur[0].id : "";
      if (lastId !== id) {
        lastId = id;
        menuItems
          .parent().removeClass("active")
          .end().filter("[href='#" + id + "']").parent().addClass("active");
      }
    });
  })(jQuery, window, document);



});

//======================= readmore button
$('.readmore-button').click(function () {
  $('.readmore-text').slideToggle();
});


//======================= Code to initialize the carousel
$(window).on('resize', function () {
  var windowWidth = $(window).width();
  if (windowWidth > 576) {
    $(".product-div").slick({
      dots: false,
      speed: 500,
      arrows: true,
      infinite: false,
      autoplay: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      prevArrow: $(".product-section .slick--prev"),
      nextArrow: $(".product-section .slick--next"),
      responsive: [{
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2
          }
        },
      ]
    });
  } else {
    $('.product-div').slick('unslick');
  }
});
$(window).trigger('resize');
